import React from 'react';
import { SimCard } from '../types';
import { useApp } from '../context/AppContext';
import './ProductCard.css';

interface ProductCardProps {
  simCard: SimCard;
}

const ProductCard: React.FC<ProductCardProps> = ({ simCard }) => {
  const { dispatch } = useApp();

  const handleAddToCart = () => {
    dispatch({ type: 'ADD_TO_CART', payload: simCard });
  };

  return (
    <div className="product-card">
      <div className="product-image">
        <img src={simCard.image} alt={simCard.name} />
        {!simCard.inStock && <div className="out-of-stock">Out of Stock</div>}
      </div>
      
      <div className="product-info">
        <h3 className="product-name">{simCard.name}</h3>
        <p className="product-region">{simCard.region}</p>
        
        <div className="product-details">
          <div className="detail-item">
            <span className="detail-label">Data:</span>
            <span className="detail-value">{simCard.dataAllowance}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Validity:</span>
            <span className="detail-value">{simCard.validity}</span>
          </div>
        </div>
        
        <div className="product-features">
          {simCard.features.slice(0, 2).map((feature, index) => (
            <span key={index} className="feature-tag">{feature}</span>
          ))}
        </div>
        
        <div className="product-coverage">
          <p className="coverage-title">Coverage:</p>
          <p className="coverage-countries">
            {simCard.coverage.slice(0, 3).join(', ')}
            {simCard.coverage.length > 3 && ` +${simCard.coverage.length - 3} more`}
          </p>
        </div>
        
        <div className="product-footer">
          <div className="price">${simCard.price}</div>
          <button 
            className="add-to-cart-btn"
            onClick={handleAddToCart}
            disabled={!simCard.inStock}
          >
            {simCard.inStock ? 'Add to Cart' : 'Out of Stock'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
